import { Routes } from '@angular/router';
import { COUNTRY_ROUTES } from './countries/country-routes';
import { SERVICETYPE_ROUTES } from './service-types/service-type-routes';
import { SAMPLEGROUP_ROUTES } from './sample-groups/sample-group-routes';
import { LANGUAGE_ROUTES } from './languages/language-routes';
import { LOCALE_ROUTES } from './locales/locale-routes';
import { FIELDMETHODOLOGY_ROUTES } from './field-methodologies/field-methodology-routes';
import { STIMULUS_ROUTES } from './stimuli/stimulus-routes';
import { FIELDSUPPLIER_ROUTES } from './field-suppliers/field-supplier-routes';
import { PARENTSAMPLESUPPLIER_ROUTES } from './parent-sample-suppliers/parent-sample-supplier-routes';
import { BUSINESSUNIT_ROUTES } from './business-units/business-unit-routes';
import { MEASUREMENTTYPE_ROUTES } from './measurement-types/measurement-type-routes';

export const CHANNEL_ROUTES: Routes = [
  {
    path: 'channels/countries',
    loadComponent: () =>
      import('./countries/all-countries/all-countries.component').then(
        (com) => com.AllCountriesComponent,
      ),
    title: 'Countries',
  },
  {
    path: 'channels/service-types',
    loadComponent: () =>
      import(
        './service-types/all-service-types/all-service-types.component'
      ).then((com) => com.AllServiceTypesComponent),
    title: 'Service Types',
  },
  {
    path: 'channels/sample-groups',
    loadComponent: () =>
      import(
        './sample-groups/all-sample-groups/all-sample-groups.component'
      ).then((com) => com.AllSampleGroupsComponent),
    title: 'Sample Groups',
  },
  {
    path: 'channels/languages',
    loadComponent: () =>
      import('./languages/all-languages/all-languages.component').then(
        (com) => com.AllLanguagesComponent,
      ),
    title: 'Languages',
  },
  {
    path: 'channels/locales',
    loadComponent: () =>
      import('./locales/all-locales/all-locales.component').then(
        (com) => com.AllLocalesComponent,
      ),
    title: 'Locales',
  },
  {
    path: 'channels/field-methodologies',
    loadComponent: () =>
      import(
        './field-methodologies/all-field-methodologies/all-field-methodologies.component'
      ).then((com) => com.AllFieldMethodologiesComponent),
    title: 'Field Methodologies',
  },
  {
    path: 'channels/stimuli',
    loadComponent: () =>
      import('./stimuli/all-stimuli/all-stimuli.component').then(
        (com) => com.AllStimuliComponent,
      ),
    title: 'Stimuli',
  },
  {
    path: 'channels/field-suppliers',
    loadComponent: () =>
      import(
        './field-suppliers/all-field-suppliers/all-field-suppliers.component'
      ).then((com) => com.AllFieldSuppliersComponent),
    title: 'Field Suppliers',
  },
  {
    path: 'channels/parent-sample-suppliers',
    loadComponent: () =>
      import(
        './parent-sample-suppliers/all-parent-sample-suppliers/all-parent-sample-suppliers.component'
      ).then((com) => com.AllParentSampleSuppliersComponent),
    title: 'Parent Sample Suppliers',
  },
  {
    path: 'channels/business-units',
    loadComponent: () =>
      import(
        './business-units/all-business-units/all-business-units.component'
      ).then((com) => com.AllBusinessUnitsComponent),
    title: 'Business Units',
  },
  {
    path: 'channels/measurement-types',
    loadComponent: () =>
      import(
        './measurement-types/all-measurement-types/all-measurement-types.component'
      ).then((com) => com.AllMeasurementTypesComponent),
    title: 'Measurement Types',
  },

  ...COUNTRY_ROUTES,
  ...SERVICETYPE_ROUTES,
  ...SAMPLEGROUP_ROUTES,
  ...LANGUAGE_ROUTES,
  ...LOCALE_ROUTES,
  ...FIELDMETHODOLOGY_ROUTES,
  ...STIMULUS_ROUTES,
  ...FIELDSUPPLIER_ROUTES,
  ...PARENTSAMPLESUPPLIER_ROUTES,
  ...BUSINESSUNIT_ROUTES,
  ...MEASUREMENTTYPE_ROUTES,
];
